// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2G4wz","legacyBtn":"MutateMid_legacyBtn___aZK5"};